module.exports = __webpack_public_path__ + "static/media/S1N13-3.c3d3f805.svg";